<script>
import BildungsportalContact from "@/components/ui/Bildungsportal/BildungsportalContact.vue";
import {mapActions, mapState} from "vuex";
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import { metricEventTypes, metricParents } from "@/lib";
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";

export default {
  name: "BildungsportalContactView",
  components: {RightColumnGroup, BildungsportalContact, Breadcrumbs},
  computed: {
    ...mapState("bildungsportal", ["contactPersons"]),
  },
  methods: {
    ...mapActions("metrics", ["postHeartbeat"]),
    ...mapActions("bildungsportal", ["loadContactPersons"]),
  },
  mounted() {
    if(!this.contactPersons) {
      this.loadContactPerson();
    }
    this.postHeartbeat({
      name: "Bildungsportal Kontaktseite",
      type: metricEventTypes.PAGE_VISIT,
      parent: metricParents.BILDUNGSPORTAL,
      data: {
        bildungsportalMetric: true,
      }
    });
  },
}
</script>

<template>
  <v-row no-gutters class="min-height-100">
    <v-col cols="12" md="8" class="new-wrapper">
      <breadcrumbs />
      <bildungsportal-contact />
    </v-col>
    <v-col
        cols="12" sm="4"
        class="contact_container pl-4"
    >
      <RightColumnGroup v-if="contactPersons" :content-object="{ personsInCharge: contactPersons }" />
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
